import * as types from "./mutation-types.articlelisting";

export default {
    setCategorySelectedId({ commit }, categoryId) {
        commit(types.SET_CATEGORY_SELECTED_ID, { categoryId });
    },
    setCategories({ commit }, categories) {
        commit(types.SET_CATEGORIES, { categories });
    }
}